import { Injectable, signal } from '@angular/core';
import { GenericTreeEntity } from '../generic-tree.entity';

@Injectable({
  providedIn: 'root'
})
export class GenericTreeHighlightService {
  readonly isDimmed = signal(false);
  readonly focusedLevel = signal<number | null>(null);

  // Data for structural checks
  readonly nodeMap = signal<Map<string, GenericTreeEntity>>(new Map());
  readonly nodeLevels = signal<Map<string, number>>(new Map());
  readonly firstNodeIdByLevel = signal<Map<number, string>>(new Map());

  setDimmed(state: boolean): void {
    this.isDimmed.set(state);
  }

  setFocusedLevel(level: number | null): void {
    this.focusedLevel.set(level);
  }

  setTreeData(entities: GenericTreeEntity[], levelMap: Map<string, number>, firstNodes: Map<number, string>): void {
    const map = new Map<string, GenericTreeEntity>();
    entities.forEach(e => map.set(e.id, e));

    this.nodeMap.set(map);
    this.nodeLevels.set(levelMap);
    this.firstNodeIdByLevel.set(firstNodes);
  }

  clearTreeData(): void {
    this.nodeMap.set(new Map());
    this.nodeLevels.set(new Map());
    this.firstNodeIdByLevel.set(new Map());
  }
}
